var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.869 7.92667C10.8621 6.69765 11.4354 5.77002 12.5959 5.08686C11.9466 4.18603 10.9657 3.6904 9.67056 3.59329C8.44447 3.49952 7.10441 4.28649 6.61397 4.28649C6.09591 4.28649 4.90781 3.62678 3.97529 3.62678C2.04809 3.65692 0 5.117 0 8.08741C0 8.9648 0.165781 9.87122 0.497343 10.8067C0.939426 12.0357 2.53507 15.0496 4.19979 14.9994C5.07014 14.9793 5.68491 14.3999 6.81775 14.3999C7.91605 14.3999 8.48592 14.9994 9.45643 14.9994C11.135 14.9759 12.5786 12.2366 13 11.0042C10.7481 9.97614 10.869 7.99029 10.869 7.92667V7.92667ZM8.91419 2.4279C9.85707 1.34288 9.77072 0.354975 9.74309 0C8.91073 0.0468835 7.94713 0.549207 7.39798 1.16874C6.79357 1.83181 6.43783 2.65227 6.51382 3.57654C7.41525 3.64352 8.23725 3.19478 8.91419 2.4279V2.4279Z",
    fill: "#323781"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple_logo.65476d28e93c80984603a2673f5c7ab2.svg";
export { ForwardRef as ReactComponent };